import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2>About Me</h2>

        <div className="about-content">
          <div className="about-text">
            <p>
              I'm Akshay Pratap Singh, a Computer Science Engineering graduate 
              currently working as a Graduate Engineer Trainee at HCL Technologies. 
              I specialize in building scalable full-stack applications using the MERN stack 
              and cloud technologies.
            </p>

            <p>
              With industry exposure across enterprise systems and startup environments, 
              I focus on writing clean, production-ready code and building solutions that 
              solve real-world problems efficiently.
            </p>

            <div className="about-stats">
              <div className="stat">
                <h3>Education</h3>
                <p>B.Tech CSE</p>
                <span>7.5 CGPA</span>
              </div>

              <div className="stat">
                <h3>Experience</h3>
                <p>Enterprise</p>
                <span>& Startups</span>
              </div>

              <div className="stat">
                <h3>Tech Stack</h3>
                <p>MERN • AWS</p>
                <span>Cloud</span>
              </div>

              <div className="stat">
                <h3>Leadership</h3>
                <p>GDSC</p>
                <span>Core Team</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default About;